import { render } from "./EditarResumenAcreditadoView.vue?vue&type=template&id=57d6459b&ts=true"
import script from "./EditarResumenAcreditadoView.vue?vue&type=script&lang=ts"
export * from "./EditarResumenAcreditadoView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__